module.exports = __webpack_public_path__ + "img/hero1.cb9230a2.jpg";